import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 bg-slate-50 relative overflow-hidden">
      <div className="absolute inset-0 dotgrid opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="relative rounded-3xl overflow-hidden ring-1 ring-slate-200 shadow-[0_30px_80px_-40px_rgba(15,23,42,0.35)]">
              <img
                src="https://images.unsplash.com/photo-1758691463582-11aea602cd4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxkZXJtYXRvbG9naXN0JTIwZG9jdG9yfGVufDB8fHx8MTc3NjQ0NTgzNHww&ixlib=rb-4.1.0&q=85"
                alt="Dermatologist using AI"
                className="w-full h-[480px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 glass rounded-xl px-4 py-3">
                <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">In the loop</div>
                <div className="text-sm font-medium text-slate-900">Human oversight, always.</div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">
              <span className="font-mono-num">01</span> · About Shushrut
            </div>
            <h2 className="font-heading mt-4 text-4xl sm:text-5xl tracking-tight font-light text-slate-900">
              Ancient wisdom, <br />
              <span className="text-slate-400">modern precision.</span>
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              Named after the ancient physician who first codified surgery,
              <span className="text-slate-900 font-medium"> Shushrut AI</span> is a
              dermatology co-pilot that pairs a hybrid deep-learning backbone
              (CNN + DenseNet121 + SwinViT) with a multi-agent AGNO framework.
              Where a single model might hesitate, four specialised agents
              deliberate — and only surface a verdict when they agree.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              The result is a second opinion that arrives in seconds, with a
              transparent trail of how it got there — built for dermatologists,
              triage teams and rural clinics alike.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6">
              {[
                { k: "Hybrid", v: "CNN · DenseNet · ViT" },
                { k: "Agents", v: "4 specialist roles" },
                { k: "Trained on", v: "ISIC 2019 / 2020" },
              ].map((x) => (
                <div key={x.k} className="border-t border-slate-200 pt-4">
                  <div className="text-[10px] uppercase tracking-[0.25em] font-mono-num text-slate-500">
                    {x.k}
                  </div>
                  <div className="text-slate-900 font-medium mt-1">{x.v}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
